import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { IApiNivell, IApiNivells } from "./api.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class Nivells {
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/cursos/`;

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $q: ng.IQService,
    private $http: ng.IHttpService
  ) { }

  init(): ng.IPromise<IApiNivell[]> {
    return this.$http.get<IApiNivells>(`${this.apiurl}findAll?`)
      .then((response) => {
        return response.data.nivells;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.$q.reject();
      });
  }
}

angularJsApp.service(AppServicesEnum.NIVELLS_SERVICE, Nivells);